import React, { Component } from 'react';
import ReactPlayer from 'react-player'

import './Videoplayer.scss';

export class Videoplayer extends Component {

  constructor(props) {
    super(props);
    let seek = (this.props.goTo) ? this.props.goTo : 0;
    this.state = { loaded: 0, playing: false, goTo : seek};
  }

  componentDidMount() {

  }
  componentDidUpdate() {
    if ((this.state.goTo !== this.props.goTo) && this.props.goTo !== 0 && !this.props.autoplay) {
      this.setState({goTo: this.props.goTo});
      this.player.seekTo(this.state.goTo, 'seconds');
    }
  }

  ref = player => {
      this.player = player
  }

  handleLoaded= () => {
   this.setState({ loaded: 1 });
   if (this.state.goTo) this.player.seekTo(this.state.goTo, 'seconds');
 }

  handlePlay = () => {
    this.setState({ playing: true })
    if (!this.props.autoplay) this.toggleCinema(false);

  }

  handlePause = () => {
    this.setState({ playing: false })
    if (!this.props.autoplay) this.toggleCinema(true);

  }

  handlePlayPause = () => {
    this.setState({ playing: !this.state.playing });
    if (!this.props.autoplay) this.toggleCinema(this.state.playing);
  }

  handleFinished = () => {
    document.body.classList.remove('body--cinema');
  }

  toggleCinema = (isCinema) => {
    if (isCinema) {
      document.body.classList.remove('body--cinema');
    } else {
      document.body.classList.add('body--cinema');
    }
  }

  render() {
    const { playing, loaded } = this.state;

    let controls = (this.props.controls === 'false' || !this.props.controls) ? false : true;
    let autoplay = (this.props.autoplay) ? this.props.autoplay : false;
    let playingState = (this.props.autoplay) ? true : playing;
    let hasPreview = this.props.preview;
    let ratio = (this.props.ratio) ? this.props.ratio : '';
    let lightImage = (hasPreview) ? hasPreview : true;

    return (
      <div className={`videoplayer ${ratio} ${(playing) ? 'playing' : ''} ${(loaded) ? 'loaded' : ''}`}>
        <ReactPlayer
          ref={this.ref}
          url={this.props.url}
          loop={this.props.loop}
          className='videoplayer__inner'
          controls={controls}
          playing={playingState}
          onReady={this.handleLoaded.bind(this)}
          onEnded={this.handleFinished.bind(this)}
          onPause={this.handlePause.bind(this)}
          onPlay={this.handlePlay.bind(this)}
          playsinline={true}
          muted={autoplay}
        />
        {!autoplay && !playing &&
          <div className="videoplayer__preview" onClick={this.handlePlayPause}>
            <div className="videoplayer__preview__image" style={{backgroundImage : 'url('+lightImage+')'}} />
            <span>{playing ? 'Pause' : 'Play'}</span>
          </div>
        }

      </div>
    )
  }

}
